import { apiSlice } from '../../app/api/apiSlice'
import { urlConfig } from '../../config'

const quickSellSlice = apiSlice.injectEndpoints({
  endpoints: build => ({
    getCoinAddress: build.query<any, string>({
      query: coin =>
        `${urlConfig.depositUrl}/deposits/deposit-addresses/${coin}`,
      providesTags: (result, error, coin) => [
        { type: 'DepositAddress', id: coin },
      ],
    }),
    getUsdtAddress: build.query<any, void>({
      query: () => `${urlConfig.depositUrl}/deposits/deposit-addresses/usdt`,
      providesTags: [{ type: 'DepositAddress', id: 'usdt' }],
    }),
    createCoinDepositAddress: build.mutation({
      query: coin => ({
        url: `${urlConfig.depositUrl}/deposits/deposit-addresses/${coin}`,
        method: 'POST',
      }),
      invalidatesTags: ['DepositAddress'],
    }),
    createUsdtDepositAddress: build.mutation({
      query: () => ({
        url: `${urlConfig.depositUrl}/deposits/deposit-addresses/usdt`,
        method: 'POST',
      }),
      invalidatesTags: ['DepositAddress'],
    }),
    watchDeposits: build.mutation({
      query: () => ({
        url: `${urlConfig.depositUrl}/deposits/deposit-addresses/watch`,
        method: 'POST',
      }),
    }),
    allDeposits: build.query<any, void>({
      query: () => `${urlConfig.depositUrl}/deposits`,
    }),

    watchCoinDeposits: build.mutation({
      query: (coin: string) => ({
        url: `${urlConfig.depositUrl}/deposits/deposit-addresses/${coin}/watch`,
        method: 'POST',
      }),
    }),

    checkWatchCoinDeposits: build.query<any, string>({
      query: (coin: string) => ({
        url: `${urlConfig.depositUrl}/deposits/deposit-addresses/${coin}/watch`,
        method: 'GET',
      }),
    }),
  }),
})

export const {
  useCreateCoinDepositAddressMutation,
  useCreateUsdtDepositAddressMutation,
  useGetCoinAddressQuery,
  useGetUsdtAddressQuery,
  useWatchDepositsMutation,
  useAllDepositsQuery,
  useWatchCoinDepositsMutation,
  useCheckWatchCoinDepositsQuery,
} = quickSellSlice
